import { QuickFiltersValueDisplayUses } from '../../../types/quickFilters/QuickFiltersValueDisplayUses';
import { useContext } from 'react';
import QuickFiltersValueDisplay from '../QuickFiltersValueDisplay';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const areOverrides = props => {
  return 'label' in props;
};
const QuickFilterTooltip = props => {
  const {
    children,
    disabled,
    property
  } = props;
  const {
    quickFiltersInternalValue
  } = useContext(SegmentationFiltersInstanceContext);
  const getTitle = () => {
    if (property.disabled && property.tooltip) {
      return /*#__PURE__*/_jsx("div", {
        children: property.tooltip
      });
    }
    if (!areOverrides(props) && props.condition && quickFiltersInternalValue) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "100",
          as: "div",
          children: property.displayName
        }), /*#__PURE__*/_jsx(Text, {
          as: "h7",
          color: "text-core-on-fill-default",
          children: /*#__PURE__*/_jsx(QuickFiltersValueDisplay, {
            condition: props.condition,
            filterFamily: quickFiltersInternalValue.filterFamily,
            use: QuickFiltersValueDisplayUses.STRING
          })
        })]
      });
    }
    if (areOverrides(props) && props.value && quickFiltersInternalValue) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "100",
          as: "div",
          children: props.label
        }), /*#__PURE__*/_jsx(Text, {
          as: "h7",
          color: "text-core-on-fill-default",
          children: props.value
        })]
      });
    }
    return /*#__PURE__*/_jsx("div", {
      children: areOverrides(props) ? props.label : property.displayName
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: disabled,
    maxInlineSize: "260px",
    title: getTitle(),
    children: children
  });
};
export default QuickFilterTooltip;